<div class="tmp-section-item-wrapper">
    <span multilang class="tmp-section-title">{{title}}</span>
    @if(!isCheckBox) {
    <div class="tmp-section-body tmp-flexy">
        <ng-container *ngFor="let item of list">
            <button class="tmp-f-btn" [class.tmp-f-btn-selected]="item.selected" [matTooltip]="item?.description"
                (click)="selectItem(item)" matRipple>{{item.name}}</button>
        </ng-container>
    </div>
    } @else {
    <div class="tour-wrapper">
        @for (item of list | slice:0:slicenbr; track $index) {
        <button class="tour-item-wrapper" (click)="selectItem(item)" [matTooltip]="item?.description" matRipple>
            <mat-icon class="tour-item-icon ">{{item.selected ? 'check_box' : 'check_box_outline_blank'}}</mat-icon>
            <span multilang class="tour-item-name">{{item.name}}</span>
        </button>
        }
        @if(list?.length > 5) {
        @if(slicenbr < list.length) { <button class="showallbtn" (click)="showMore(list.length)" matRipple>
            <span multilang>alle {{list.length}} anzeigen</span>
            </button>
            } @else {
            <button class="showallbtn" (click)="showMore(5)" matRipple>
                <span multilang>weniger anzeigen</span>
            </button>
            }
            }
    </div>
    }
</div>